const GlossaryHeader = () => {
	return (
		<div className="col-span-full flex w-full flex-col items-center justify-center gap-4 rounded-2xl from-slate-50 text-center sm:gap-6 sm:p-16">
			<div className="absolute top-0 h-72 w-full bg-polka sm:h-96"></div>
			<div className="absolute top-0 h-72 w-full bg-gradient-to-b from-transparent to-white sm:h-96 dark:to-slate-800"></div>

			<h1 className="relative max-w-72 font-semibold text-2xl sm:max-w-max md:text-4xl">
				The Brookbush Institute Glossary
			</h1>
			<p className="relative -mt-2 -mb-1 sm:text-lg">
				A list of terms and definitions used in our courses and articles.
			</p>
		</div>
	);
};

export default GlossaryHeader;
